module.exports = __webpack_public_path__ + "img/mj_partners_1_xinjiang.6c699ddc.png";